import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import config from '../config/config'

export function createWidgetRouter(routes: RouteRecordRaw[]) {
  return createRouter({
    history: createWebHashHistory(config.baseUrl),
    routes
  })
}
